import { platform } from "platformImpl";

export const openDrawer = (callback) => {
    
    if (platform.isWeb) {
        if (callback instanceof Promise) {
            return callback;
        } else if (typeof callback === 'function') {
            const returnVale = callback();
            if (isPlainObject(returnVale)) {
                return returnVale;
            }
        }
    }

    return {
        type: 'DRAWER_PDF_OPEN',
        payload: callback
    }
    
};

export const closeDrawer = (data) => {
    return {
        type: 'DRAWER_PDF_CLOSE',
        payload: data
    }
};

export const setDrawerType = (data) => {
    return {
        type: 'DRAWER_PDF_TYPE',
        payload: data
    }
};

const isPlainObject = (obj) => {
    
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }

    let proto = obj;

    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }

    return Object.getPrototypeOf(obj) === proto;

}